<template>
  <div class="volunteers-send-notifications">
    <volunteers-selector @onSubmit="onOpenNotificationPopup" btn-label="إرسال إشعار جديد" btn-icon="icon-send" />

    <tm-popup :submit="onNotificationPopupSubmit" title="إرسال إشعار" ref="notificationPopup" submitButtonLabel="إرسال">
      <div class="vx-row justify-start">
        <div class="vx-col w-full mb-2 mt-2">
          <tm-input class="w-full" name="العنوان" placeholder="العنوان" type="text" validation-rules="required"
            v-model="notification.title" />
        </div>
        <div class="vx-col w-full mb-2 mt-2">
          <tm-input class="w-full" name="الرابط" placeholder="الرابط" type="text"
            :validation-rules="{ required: false, regex: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/ }"
            v-model="notification.link" />
        </div>
        <div class="vx-col w-full mb-2 mt-4">
          <p class="mt-2 px-2" style="font-size: smaller">الوصف</p>
          <tm-text-area class="w-full" name="الوصف" validation-rules="required" v-model="notification.description" />
        </div>
      </div>
    </tm-popup>
  </div>
</template>

<script>
import { RepositoryFactory } from '../volunteer-repositories/volunteerRepositoryFactory';
import TmPopup from "@/app/shared/shared-components/TmPopup";
import TmInput from "@/app/shared/shared-components/TmInput";
import TmTextArea from "@/app/shared/shared-components/TmTextArea";
import VolunteersSelector from "../components/VolunteersSelector.vue";

const volunteerRepo = RepositoryFactory.get('volunteerRepository');

export default {
  name: "VolunteersSendNotifications",
  components: {
    TmPopup,
    TmInput,
    TmTextArea,
    VolunteersSelector
  },
  data() {
    return {
      volunteers: null,
      notification: {
        title: null,
        link: null,
        description: null,
        imageUrl: null,
        channel: "fcm",
      },
    };
  },
  methods: {
    onOpenNotificationPopup(payload) {
      this.resetNotificationForm();
      this.$refs.notificationPopup.open();
      this.volunteers = payload;
    },
    resetNotificationForm() {
      this.volunteers = null;
      Object.assign(this.notification, {
        title: null,
        link: null,
        description: null,
        imageUrl: null,
        channel: "fcm",
      });
    },
    async onNotificationPopupSubmit() {
      const payload = {
        ...this.notification,
        excludedVolunteerIds: this.volunteers.excludedVolunteer,
      };
      try {
        await volunteerRepo.sendNotifications(
          {
            payload,
            query: this.volunteers.query
          }
        );
        this.$refs.notificationPopup.close();
        await this.gridApi.refreshServerSideStore({ purge: true });
        this.resetNotificationForm();
      } catch (err) {
        this.$refs.notificationPopup.endLoading();
      }
    },
  },
};
</script>
